import React, { useEffect, useState } from "react";
import { searchAllObjects, searchObject } from "../firebase/fireQueries";
import useHandleBoxTypes from "./useHandleBoxTypes";
import useTimer from "./useTimer";

const useFirebaseSearch = ({
  searchInput,
  type,
  onSearched,
  pauseInterval = 10,
  includeCategories,
  searching = true,
}) => {
  const timer = useTimer();
  const [lastSearch, setLastSearch] = useState(null);
  const { getBoxType } = useHandleBoxTypes();

  function categorizeSearchResults(result) {
    const search = searchInput.replace(/[^a-z]/gi, "").toLowerCase();
    const exact = result.filter((doc) => doc.id == search);
    const partially = result.filter((doc) => doc.searchArray.includes(search));
    const keywords = result.filter((doc) => doc.keywords.includes(search));
    const categories = result.filter((doc) => doc.categories.includes(search));
    const resultObj = {
      exact,
      partially,
      keywords,
      categories,
      open: [],
      saved: [],
      general: [],
    };

    if (includeCategories)
      resultObj.categories = result.filter((doc) =>
        doc.categories.includes(search)
      );
    else resultObj.categories = [];
    onSearched(resultObj);
  }

  useEffect(() => {
    const search = searchInput.replace(/[^a-z]/gi, "").toLowerCase();
    if (!lastSearch && search.length > 3 && searching) {
      if (type != "all") {
        const bType = getBoxType(type);
        searchObject(search, bType, categorizeSearchResults);
      } else searchAllObjects(search, categorizeSearchResults);
      setLastSearch({
        input: search,
        time: timer.smallTick,
      });
    }
    if (lastSearch && search.length > 3) {
      if (
        lastSearch.input != search &&
        timer.smallTick - lastSearch.time > pauseInterval &&
        searching
      ) {
        if (type != "all") {
          const bType = getBoxType(type);
          searchObject(
            search,
            bType,
            categorizeSearchResults,
            includeCategories
          );
        } else searchAllObjects(search, categorizeSearchResults);
        setLastSearch({
          input: search.toLowerCase(),
          time: timer.smallTick,
        });
      }
    } else if (lastSearch && search.length < 4) {
      setLastSearch(null);
    }
  }, [timer.smallTick]);
};

export default useFirebaseSearch;
